import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-selecao-relatorio',
  templateUrl: './selecao-relatorio.page.html',
  styleUrls: ['./selecao-relatorio.page.scss'],
})
export class SelecaoRelatorioPage implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
  }


  async onSubmit2(tipo: string) {
    console.log(tipo);
    if(tipo === "caixa"){
      try {
        this.router.navigate(['/controle-caixa']);
      } catch (error) {
        console.log(error);
      }
    }else{
    try {
      this.router.navigate(['/relatorio/',tipo]);
    } catch (error) {
      console.log(error);
    }
  }

  }


}
